import { createSlice } from "@reduxjs/toolkit";

export interface InitialState {
  referenceName: string;
  linkVisited: boolean;
}

const initialState: InitialState = {
  referenceName: "",
  linkVisited: false,
};

const referenceSlice = createSlice({
  name: "reference",
  initialState,
  reducers: {
    setReferenceName: (state, { payload }) => {
      state.referenceName = payload;
    },
    toggleVisited: (state, { payload }) => {
      state.linkVisited = payload;
    },
  },
});

export const { setReferenceName, toggleVisited } = referenceSlice.actions;

export default referenceSlice.reducer;
